import { cva, type VariantProps } from 'noddi-ui-common';

/**
 * Shared by `WorkerAvatar` and `ExpectedStaffingAvatar` so a person and a non-person line up
 * in the same column. `filled` + a name paints from the name-derived color at the call site.
 */
export const avatarVariants = cva('flex shrink-0 items-center justify-center rounded-full font-semibold', {
  variants: {
    size: {
      xs: 'size-5 text-[9px]',
      sm: 'size-6 text-[10px]',
      md: 'size-8 text-xs',
      lg: 'size-12 text-base',
      xl: 'size-16 text-xl'
    },
    variant: {
      filled: '',
      outline: 'border border-silverGray bg-white'
    },
    /** No name to derive initials or a color from — falls back to a neutral person glyph. */
    hasName: {
      true: '',
      false: 'text-muted-foreground'
    }
  },
  compoundVariants: [
    { variant: 'outline', hasName: true, class: 'text-darkPurple' },
    { variant: 'filled', hasName: false, class: 'bg-muted' }
  ],
  defaultVariants: {
    size: 'sm',
    variant: 'filled',
    hasName: true
  }
});

export type AvatarSize = NonNullable<VariantProps<typeof avatarVariants>['size']>;
